import styled from 'styled-components';

export namespace S {
	export const Container = styled.div`
		display: flex;
		flex: 1;
		flex-flow: column;
		gap: ${({ theme }) => theme.spacings.small};
		padding: ${({ theme }) => theme.spacings.xxlarge} 0;

		${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
			padding: ${({ theme }) => theme.spacings.large} ${({ theme }) => theme.spacings.small};
		}
	`;

	export const LoadingWrapper = styled.div`
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		width: 100%;
	`;

	export const Title = styled.h1`
		${({ theme }) => theme.fonts.headings.title5};
		color: ${({ theme }) => theme.colors.text.main.enabled};
		margin: 0;
	`;

	export const Subtitle = styled.h2`
		${({ theme }) => theme.fonts.text.text3};
		color: ${({ theme }) => theme.colors.text.main.enabled};
		margin: 0;
		display: flex;
		align-items: center;
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;

	export const WalletTabContainer = styled.section`
		align-items: center;
		display: flex;
		flex: 1;
		flex-flow: column;

		padding: ${({ theme }) => theme.spacings.small};
		${({ theme }) => theme.breakpoints.queries.above.mobile} {
			padding: ${({ theme }) => theme.spacings.large};
		}
		${({ theme }) => theme.breakpoints.queries.above.tabletSmallDesktop} {
			padding: ${({ theme }) => theme.spacings.xlarge} ${({ theme }) => theme.spacings.small};
		}
	`;
}
